module.exports = __webpack_public_path__ + "media/multi-action.0d15a7c9.mp4";